class ConfirmationController {
  constructor ($state, $cookies) {

      $cookies.remove('request');
      this.request = $state.params.request

      if(!this.request) {
          this.$state.go('app.home');
      }
  }
}

ConfirmationController.$inject = ['$state', '$cookies'];

export {ConfirmationController};



/** WEBPACK FOOTER **
 ** ./src/app/components/booking/confirmation/confirmation.controller.js
 **/